import { useState, useRef, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useError, useNavLinks } from ".";
import { fetchGet } from "../utils";

export default function useCurrentPublicPost() {
  const { id } = useParams();
  const { setError } = useError();
  const { updateNavButtons } = useNavLinks();
  const isFetching = useRef(false);
  const [currentPost, setCurrentPost] = useState(null);

  useEffect(() => {
    (async () => {
      if (currentPost && currentPost.id === id) {
        return currentPost;
      }
      const params = new URLSearchParams({ id });
      const url = `/public/?` + params.toString();
      if (isFetching.current) {
        return;
      }
      isFetching.current = true;
      const { body, error } = await fetchGet({
        url,
      });
      if (error) {
        setError(error);
      }

      if (body && body.date) {
        updateNavButtons({ nextCurrentPost: {}, showEditButton: false });
        setCurrentPost(body);
      } else {
        setCurrentPost({
          title: "Not Found",
          content: "We're sorry, we were unable to find this post.",
        });
      }
      isFetching.current = false;
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return { currentPost };
}
